//export const API_ROOT = process.env.NODE_ENV === "production" ? "/api/" : "/api/";

export const API_ROOT =
  process.env.NODE_ENV === "production"
    ? process.env.CORDOVA_PLATFORM
      ? "https://leas-e.makerspace.at/api/"
      : "/api/"
    : "/api/";
